import {h, Fragment} from "preact"
import {colorFacetPairs} from "../../config"

export default function Checkbox({ value, selected, onChange, className, isColorFacet }) {
    return (
        <>
        <label className={`ns-checkbox ns-d-block ns-color-black ${className}`}>
            <input type="checkbox" checked={selected} onChange={onChange} />
           {isColorFacet ? "" : <span className="ns-checkmark" />}
           {isColorFacet && <>
           <span
                style={{
                backgroundImage: `url(${value})`, 
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                display: "inline-block", 
                backgroundSize: "cover",
                backgroundPosition: "center",
                // marginLeft: "11px",
                // marginRight: "2px"
                }}
            ></span>
            <span class="color__name ns-color-name">{colorFacetPairs[value]}</span>
            </>}
        </label>
         {!isColorFacet && <div>{value}</div>}
        </>
    )
}